const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const JsonBuilderCommand: any = {
    CreateJsonTemplate: Backofficebff + '/v1/json/templates',
    DeleteJsonTemplate: Backofficebff + '/v1/json/templates',
    UpdateJsonTemplate: Backofficebff + '/v1/json/templates',
};
